import { useState, type FormEvent } from "react";
import { makeId } from "@otrack/domain";
import { Button, Field, Modal, Select, TextInput } from "@otrack/ui";
import { currencyOptions } from "./components";
import { useApp, useDataset, useFactory } from "./context";
import { navigate } from "./router";

export function ClientEditor({ onClose }: { onClose: () => void }) {
  const { act } = useApp();
  const dataset = useDataset();
  const factory = useFactory();
  const [name, setName] = useState("");
  const [currency, setCurrency] = useState(dataset.settings.defaultCurrency);
  const [error, setError] = useState<string | null>(null);

  const save = async (event: FormEvent) => {
    event.preventDefault();
    if (!name.trim()) return setError("Name the client.");
    const id = makeId("client");
    await act([factory.op("client", id, { name: name.trim(), defaultCurrency: currency === dataset.settings.defaultCurrency ? null : currency })], `Created ${name.trim()}`);
    onClose();
    navigate({ page: "client", id });
  };

  return <Modal title="New client" icon="user" description="Who pays for the work. Projects group under it." onClose={onClose}>
    <form className="ot-form" onSubmit={(event) => void save(event)} noValidate>
      <Field label="Name" error={error}>
        <TextInput value={name} onChange={(event) => { setName(event.target.value); setError(null); }} maxLength={200} placeholder="e.g. Lumen Atelier" autoFocus/>
      </Field>
      <Field label="Currency" hint="Their projects bill in this unless you pick another.">
        <Select value={currency} onChange={setCurrency} options={currencyOptions([dataset.settings.defaultCurrency])}/>
      </Field>
      <div className="ot-form__actions"><span className="ot-form__spacer"/><Button type="button" onClick={onClose}>Cancel</Button><Button type="submit" tone="primary" icon="plus">Create client</Button></div>
    </form>
  </Modal>;
}
